<template>
  <v-dialog v-model="isActive" v-bind="$attrs" persistent max-width="500px">
    <v-card>
      <v-card-title class="text-h6 mr-4" style="word-break: break-word;">
        {{ modalMessage }}
      </v-card-title>
      <v-card-text>
        <div v-if="errorReport" class="error--text">
          {{ errorReport }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" :disabled="!report" @click="isActive = false">
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CollectorUploadApi } from '@/api/resources/Collector/CollectorUpload'
import { KimUserStatus } from '@/typings/api/CollectorPublication'

export default {
  name: 'BaseUploadCollectorFileModal',
  inheritAttrs: false,
  props: {
    file: File,
    publicationId: String,
    type: String,
  },
  data: () => ({
    errorReport: null,
    report: null,
    isActive: false,
  }),
  computed: {
    modalMessage() {
      if (!this.report) {
        return 'Пожалуйста, не покидайте страницу, иначе загрузка прервется.'
      }

      switch (this.report.status) {
        case KimUserStatus.pending:
          return 'Файл загружен'
        case KimUserStatus.done:
          return 'Файл загружен'
        case KimUserStatus.error:
          return 'Не удалось загрузить файл'
        default:
          return this.report.status
      }
    },
  },
  created() {
    this.api = new CollectorUploadApi()
    this.uploadKimVariants()
  },
  methods: {
    open() {
      this.isActive = true

      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    async uploadKimVariants() {
      this.report = null
      this.errorReport = null
      try {
        const { data } = await this.api.upload(
          this.file,
          this.publicationId,
          this.type,
        )
        this.report = data.task
        this.errorReport = data.task.exc_info
        return data
      } catch (e) {
        this.$notice.errors(e)
        return Promise.reject(e)
      }
    },
  },
}
</script>
